/**
 * @(#)2019/6/17.
 * Phone，可以输入手机或电话号码
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import Basics from "./Basics";
import Utils from "../../utils";
import ReactDOM from "react-dom";
import { cloneDeep } from "../../utils";
import React, { Component } from "react";
import { l } from "../../config/language";
import { YxComponent, Connection } from "../YxComponent";
import { IphonePropTypes } from "./IpropType/phonePropType";
/*
 * @param type {enum} 控件类型 mobile/telephone  手机/电话
 * @param children {ReactNode} react节点
 * @param styleParam {object} 样式参数
 * @param styleParam.width {object} 宽度  xxs,xs,sm,md,lg,xl
 * */

//默认props
let defaul = () => {
  return {
    inputParam: {},
    type: "mobile", //mobile/tel  手机/电话
    children: "", //子节点
    rules: {},
    styleParam: {
      width: "sm", //宽度  xxs,xs,sm,md,lg,xl
      size: "default", //大小
      type: "default", //类型
    },
  };
};
@Connection(defaul)
class Phone extends YxComponent {
  productionHtml() {
    let tmpProps = { ...this.props };
    // tmpProps.rules = tmpProps.rules);
    if (tmpProps.type == "mobile") {
      tmpProps.rules.mobile = {
        pattern: /^1[3456789]\d{9}$/,
        message: l("Phone.pem", this),
      };
    }
    if (tmpProps.type == "tel") {
      tmpProps.rules.tel = {
        pattern: /^(\(\d{3,4}\)|\d{3,4}-)?\d{7,8}$/,
        message: l("Phone.tem", this),
      };
    }

    let classParam = {
      yx_yxInput_: "styleParam.type",
      yx_yxInput_width_: "styleParam.width",
      yx_yxInput_size_: "styleParam.size",
    };
    tmpProps.inputParam.className = this.styleParamClassName(
      tmpProps,
      classParam
    );

    let html = Basics.html(tmpProps);
    return html;
  }

  render() {
    return <div className="yx_yxInput_phone">{this.productionHtml()}</div>;
  }
}

Phone.propTypes = IphonePropTypes;

Phone.defaultProps = defaul();

export default Phone;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Phone.js